import SanitizedGrid from "../../../components/SanitizedGrid";
import { Grid, Typography } from "@material-ui/core";
import {
  FormDataConsumer,
  RadioButtonGroupInput,
  required,
  SimpleForm,
} from "react-admin";
import React, { useState } from "react";
import CalculationCostStudentButton from "./CalculationCostStudentButton";
import { scheduleTypeList } from "../../dashboard/const";
import RegularCostCalculationInput from "./RegularCostCalculationInput";
import CcaCostCalculationInput from "./CcaCostCalculationInput";
import CostCalculationPreview from "./CostCalculationPreviewTable";

const CalculateAreaInput = () => {
  const [resultRegularCalculations, setResultRegularCalculations] = useState<
    IResultCalculation[]
  >([]);
  const [resultCcaCalculations, setResultCcaCalculations] = useState<
    IResultCcaCalculation[]
  >([]);
  const [isLoaded, setIsLoaded] = useState(false);
  const [scheduleType, setScheduleType] = useState<string>();
  const [dropOffType, setDropOffType] = useState<string>();

  const dropOffTypeCallback = (value: string) => {
    setDropOffType(value);
  };

  return (
    <SimpleForm toolbar={null}>
      <SanitizedGrid container spacing={2}>
        <Grid item xs={12} style={{ marginBottom: -20 }}>
          <RadioButtonGroupInput
            source="scheduleType"
            choices={scheduleTypeList}
            validate={required()}
            onChange={(e) => {
              setScheduleType(e as unknown as string);
            }}
          />
        </Grid>
        {(scheduleType === "regular" || scheduleType === "both") && (
          <RegularCostCalculationInput />
        )}

        {(scheduleType === "cca" || scheduleType === "both") && (
          <CcaCostCalculationInput dropOffTypeCallback={dropOffTypeCallback} />
        )}

        {isLoaded && (
          <SanitizedGrid container spacing={2} style={{ marginBottom: 10 }}>
            {resultRegularCalculations.length > 0 ||
            resultCcaCalculations.length > 0 ? (
              <>
                {resultRegularCalculations.length > 0 && (
                  <>
                    <Grid item xs={12} style={{ marginBottom: -10 }}>
                      <Typography variant="h5">Regular Cost Preview</Typography>
                    </Grid>
                    {resultRegularCalculations.map(
                      (resultCalculation: IResultCalculation) => (
                        <Grid item xs={12}>
                          <Typography variant="h6">
                            Cost Preview for Rate Chart #
                            {resultCalculation.rateChart.id} -{" "}
                            {resultCalculation.rateChart.name}
                          </Typography>
                          <CostCalculationPreview
                            resultCalculationTransactions={
                              resultCalculation.transactions
                            }
                          />
                        </Grid>
                      ),
                    )}
                  </>
                )}
                {resultCcaCalculations.length > 0 && (
                  <>
                    <Grid
                      item
                      xs={12}
                      style={{ marginTop: 10, marginBottom: -10 }}
                    >
                      <Typography variant="h5">CCA Cost Preview</Typography>
                    </Grid>
                    {resultCcaCalculations.map(
                      (resultCalculation: IResultCcaCalculation) => (
                        <Grid item xs={12}>
                          <Typography variant="h6">
                            Cost Preview for Rate Chart #
                            {resultCalculation.ccaRateChart.id} -{" "}
                            {resultCalculation.ccaRateChart.name}
                          </Typography>
                          <CostCalculationPreview
                            resultCalculationTransactions={
                              resultCalculation.transactions
                            }
                          />
                        </Grid>
                      ),
                    )}
                  </>
                )}
              </>
            ) : (
              <Grid item xs={12}>
                <Typography variant="h6">No Change in Cost.</Typography>
              </Grid>
            )}
          </SanitizedGrid>
        )}

        <Grid item xs={12}>
          <FormDataConsumer>
            {({ formData }) => {
              formData.scheduleType = scheduleType;
              formData.dropOffType = dropOffType;
              return (
                <div>
                  <CalculationCostStudentButton
                    setResultRegularCalculations={setResultRegularCalculations}
                    setResultCcaCalculations={setResultCcaCalculations}
                    setIsLoaded={setIsLoaded}
                    formData={formData}
                  />
                </div>
              );
            }}
          </FormDataConsumer>
        </Grid>
      </SanitizedGrid>
    </SimpleForm>
  );
};

export default CalculateAreaInput;
